import { canUserViewReportLink } from "./can-user-view-report-link.js";

/**
 * Filtra report-links visíveis para o usuário logado.
 * @param {Object[]} reportLinks
 * @param {Object[]} userRoles
 * @returns {Object[]}
 */
export function filterReportLinksByUserRoles(reportLinks, userRoles) {
  const rows = Array.isArray(reportLinks) ? reportLinks : [];
  return rows.filter((item) => canUserViewReportLink(item, userRoles));
}
